import { Router,NavigationEnd } from '@angular/router';
import { LanguageService } from './../../../shared/services/language/language.service';
import { Component, OnInit, HostListener, HostBinding, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { UserService } from '../../service/user.service'
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from 'src/app/shared/dialogs/logout/logout.component';
import { UserData } from '../../core.interface';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit,AfterViewInit {
  selected='nl';
  selectedOption;
  showWatchViewBtn: boolean = false;
  showDialog = false;
  dialogPosition = { top: 0, left: 0 };
  isUserLoggedIn: boolean = false;
  userDetails : UserData = this.userService.getUserData() || null;
  @ViewChild('userImage', { static: false }) userImage!: ElementRef;
  isStudentTeamPlay: boolean = false;

  navObject :
  {icon:string,text:string,link:string} = {
    icon : 'assets/icons/play_btn_red.svg',
    text : 'Watch videos',
    link : '/list-view'
  }

  selectedLanguage = '';
  blnMobSidebar = false;
  aboutUsClicked = false;

  selectedAboutUs = "ABOUT US";

  langs = [
    { key: 'en', value: 'English' },
    { key: 'nl', value: 'Dutch' }
  ];
  selectedLanguageSubscriber;

  langOptions = [
    {val:"nl",lan:"DUTCH",flag:"🇳🇱"},
    {val:"en",lan:"ENG",flag:"🇬🇧"}
    ]

  constructor(private translate: TranslateService,
    private userService: UserService,
    private languageservice: LanguageService,
    private loaderService:LoaderService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private router: Router) {
    this.selectedOption = 'option2';

  }
  ngAfterViewInit(): void {
    // throw new Error('Method not implemented.');
    this.loaderService.profileDialog.subscribe((val: boolean) => {
      this.showDialog = val;
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.languageservice.translateLanguge.subscribe((value) => {
      this.selectedLanguage =  value ? value
      : localStorage.getItem('userLang') ? localStorage.getItem('userLang')
      : 'nl';
      // this.selectedLanguage = value;
    });
    // if (localStorage.getItem('userLang')) {
    //   this.setLang(localStorage.getItem('userLang'));
    // } else {
    //   this.translate.use(this.selectedLanguage);
    // }
    // Subscribe to the login state observable
    this.userService.isLoggedIn$.subscribe(isLoggedIn => {
      this.isUserLoggedIn = isLoggedIn;
      this.userDetails = this.userService.getUserData();
    });
    this.setLang(this.selectedLanguage);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkNavigation(event.url)
        // this.showWatchViewBtn = event.url === '/list-view';
      });
  }

  checkNavigation(url:string){
    this.showWatchViewBtn = true;
    if(url == '/list-view'){
      this.navObject.icon = 'assets/icons/red-medal.svg';
      if(this.userDetails){
        this.navObject.text = this.userDetails.role == 1 ? 'Play expedition' : 'Start quiz';
        this.navObject.link = this.userDetails.role == 1 ? '/map-view' : '/category';
      } else {
        this.navObject.text = 'Play expedition';
        this.navObject.link = '/login';
      }
      // this.userService.mapView = this.isUserLoggedIn ? 'EXPEDITION' : 'VIDEOS'
    } else if(url == '/login'){
      this.navObject.icon = 'assets/icons/play_btn_red.svg';
      this.navObject.text = 'Watch videos';
      this.navObject.link = '/list-view';
    } else if(url == '/map-view'){
      let view = this.userService.mapView === 'EXPEDITION'
      this.userService.mapView = view ? 'VIDEOS' : 'EXPEDITION';
      this.navObject.icon = 'assets/icons/play_btn_red.svg';
      this.navObject.text = 'Watch videos';
      this.navObject.link = '/list-view';
    } else if(url.includes('/question')){
      this.showWatchViewBtn = false;
    } else if(url.includes('/category')
      || url.includes('/instructions')
      || url.includes('/join-team')
      || url.includes('/leaderboard')
      || url.includes('/quiz-completed')
    ){
      this.navObject.icon = 'assets/icons/play_btn_red.svg';
      this.navObject.text = 'Watch videos';
      this.navObject.link = '/list-view';
    }

    if(  url.includes('/loby')
      || url.includes('/quiz-begin')
      || url == '/quiz'
      || url.includes('/quiz-finished')
    ){
      this.isStudentTeamPlay = true;
    }
  }

  gotoVideos(){
    this.router.navigateByUrl('/list-view')
  }

  goToHome(){
    if(this.userDetails){
      this.router.navigateByUrl(this.userDetails.role == 1 ? '/map-view' : '/list-view')
    } else {
      this.router.navigateByUrl('/login')
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
  }

  setLang(language) {

    this.languageservice.translateLanguge.next(language);
    localStorage.setItem('userLang', language);
    this.translate.use(this.selectedLanguage);
    if (this.selectedLanguage == 'nl') {
      if (this.selectedAboutUs == 'WORLD INTO YOUR CLASSROOM' || this.selectedAboutUs == 'GLOBAL') {
        this.selectedAboutUs = "ABOUT US";
      }

    } else {
      this.selectedAboutUs = "ABOUT US";
    }

    this.reloadPageFunction();

  }

  reloadPageFunction() {
    //this.router.navigate([this.router.url])
    //console.log('reload')
    // this.router.navigateByUrl('/');
  }

  headerToggle() {
    this.blnMobSidebar = !this.blnMobSidebar;
  }

  headerClicked(header) {
    // console.log(header);
    if (this.selectedLanguage == 'nl') {
      if (header == 'HOME') {
        this.router.navigate(['/']);
      } else if (header == 'ABOUT US') {
        window.open("https://global-exploration.nl/over-ons/", "_blank")
      } else if (header == 'WHO IS WHO') {
        window.open("https://global-exploration.nl/wie-is-wie/", "_blank")
      } else if (header == 'FINANCES') {
        window.open("https://global-exploration.nl/financien/", "_blank")
      } else if (header == 'PREPARATIONS') {
        window.open("https://global-exploration.nl/voorbereiding/", "_blank")
      }
      else if (header == 'GLOBAL') {
        window.open("https://global-exploration.nl/global/", "_blank")
      } else if (header == 'PRIVACY') {
        window.open("https://global-exploration.nl/privacy/", "_blank")
      } else if (header == 'WORLD') {
        window.open("https://global-exploration.nl/location/xplore-europe/", "_blank")
      }
      else if (header == 'EXPLORE') {
        window.open("https://global-exploration.nl/location/xplore-europe/", "_blank")
      }
      else if (header == 'INFORMATIE') {
        window.open("https://global-exploration.nl/ouder-informatie-2021/", "_blank")
      }
      else if (header == 'GROPEN') {
        window.open("https://global-exploration.nl/groepen/", "_blank")
      }
      else if (header == 'DESTINATIONS') {
        window.open("https://global-exploration.nl/bestemmingen/", "_blank")
      } else if (header == 'Global Challenge') {

        window.open("https://global-exploration.nl/global-challenge/");

      }
      else if (header == 'CONTACT') {
        window.open("https://www.global-exploration.nl/contact", "_blank")
      } else if (header == 'MYSGE') {
        window.open("https://global-exploration.nl/mijnsge1920/", "_blank")
      } else if(header == 'Watch videos'){
        this.headerToggle();
        this.router.navigateByUrl('/list-view');
      }

    } else {
      if (header == 'HOME') {
        this.router.navigate(['/']);
      } else if (header == 'ABOUT US') {
        window.open("https://global-exploration.nl/en/about-us-2/", "_blank")
      } else if (header == 'WHO IS WHO') {
        window.open("https://global-exploration.nl/en/who-is-who/", "_blank")
      } else if (header == 'FINANCES') {
        window.open("https://global-exploration.nl/en/finance/", "_blank")
      } else if (header == 'PREPARATIONS') {
        window.open("https://global-exploration.nl/en/preparation/", "_blank")
      }
      else if (header == 'PRIVACY') {
        window.open("https://global-exploration.nl/en/privacy/", "_blank")
      }
      else if (header == 'EXPLORE') {
        window.open("https://global-exploration.nl/en/xplore-europe/", "_blank")
      }

      else if (header == 'DESTINATIONS') {
        window.open("https://global-exploration.nl/en/destinations/", "_blank")
      } else if (header == 'Global Challenge') {
        window.open("https://global-exploration.nl/global-challenge/");

      }
      else if (header == 'CONTACT') {
        window.open("https://www.global-exploration.nl/contact", "_blank")
      } else if (header == 'MYSGE') {
        window.open("https://global-exploration.nl/mijnsge1920/", "_blank")
      } else if(header == 'Watch videos'){
        this.headerToggle();
        this.router.navigateByUrl('/list-view');
      }
    }


    this.blnMobSidebar = false;
  }
  @HostListener('click', ['$event']) click(e) {
    e.stopPropagation();
  }

  @HostListener("document:click") resetToggle() {
    if (this.blnMobSidebar) {
      this.blnMobSidebar = false;
    }
  }

  logOut() {
    this.toggleDialog();

      const dialogRef = this.dialog.open(LogoutComponent, {
        disableClose: true,
        // width:'500px',
      });
      dialogRef.afterClosed().subscribe((data:boolean)=>{
        if(data){
          sessionStorage.setItem('lFragment','0')
          this.userService.logout();
          this.router.navigateByUrl('/login');
        }
      })

  }
}
